export const SESSION_WARNING_TIMEOUT = 120; // This 2 mins time will be used to show warning time to user in Idle
export const TOKEN_EXPIRATION_MIN = 2; // X mins before token expiration user is warned to renew
export const DEFAULT_PAGE_SIZE = 10; // Default page size for data grid
